import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { now } from '@/utils'
import store from '@/store'
import router from '@/router'
import i18n from '@/lang'
import { getEnvObj } from '@/utils/env'
// import { getToken } from '@/utils/auth'
import { getUrlKey } from '@/utils'
import { MSG_URL } from './constant'
import { clientTimeZone } from '@/utils/moment'
import md5 from 'js-md5' //  md5
var timezone = clientTimeZone()

const envObj = getEnvObj()
let site = envObj.SITE[envObj.CURRENT_SITE]
// debugger
if (site.indexOf('http://localhost:7080') > -1) {
  site = site + process.env.VUE_APP_BASE_API
}
const service = axios.create({
  baseURL: window.__POWERED_BY_QIANKUN__ ? site : (process.env.VUE_APP_BASE_API || ''), // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
})

let MessageError = null
const messageCommmonConfig = {
  duration: 10 * 1000,
  showClose: true,
}

// const loginPage = window.localStorage.getItem('loginPage')
const goPage = (query) => {
  // if (loginPage === '2') {
  //   router.push({
  //     path: '/old-login',
  //     query })
  // } else {
  router.push({
    path: '/login',
    query })
  // }
}

// 请求拦截
service.interceptors.request.use(
  config => {
    // 过滤请求头中的换行符，防止 CRLF 注入
    Object.keys(config.headers).forEach(key => {
      if (typeof config.headers[key] === 'string') {
        config.headers[key] = config.headers[key].replace(/[\r\n]/g, '')
      }
    })

    restfulHandler(config) // 处理reset ful
    if (process.env.VUE_APP_BASE_API === '/dev-api') { //  开发环境
      // config.headers['sgs-userid'] = '1' // 企业-1月21日
    }
    if (window.__POWERED_BY_QIANKUN__) {
      console.log('store.getters.token', store.getters.token)
      config.headers['token'] = store.getters.token
      config.headers['intl_gray_wapp'] = '1'
    }
    if (config.url.indexOf('/icas-service') > -1) {
      const myDate = new Date()
      const traceId = md5('' + myDate.getTime() + Math.floor(Math.random() * 10000))
      config.headers['traceId'] = traceId
    }
    let str_lang = store.getters.language || localStorage.getItem('localLangCode') || 'zh-CN'
    str_lang.includes('en')
    str_lang = 'en-US'
    config.headers['user_lang'] = str_lang
    // 操作端(移动、PC端)
    config.headers['user_agent_type'] = 1 // 1-PC  2-APP 3-H5 4-微信小程序
    const lang = store.getters.language || localStorage.getItem('localLangCode') || 'zh-CN'
    config.headers['lang'] = config.headers.customedHeaderLang || lang
    config.headers['user_country'] = JSON.parse(localStorage.getItem('localSiteConfig') || '{}').country || 'CN'
    config.headers['timezone'] = timezone
    // 每个请求都加入一个时间戳，主要是解决IE浏览器页面缓存不请求接口，重复请求页面不刷新的问题。
    if (config.method === 'post') {
      if (Object.prototype.toString.call(config.data) === '[object Object]') {
        config.data = {
          ...config.data,
          t: now()
        }
      } else if (Object.prototype.toString.call(config.data) === '[object FormData]') {
        const newFormData = new FormData()
        config.data.forEach((value, key) => {
          newFormData.append(key, value)
        })
        newFormData.append('t', now())
        config.data = newFormData
        // config.data.append('t', now())
      }
    } else if (config.method === 'get') {
      config.params = {
        ...config.params,
        t: now()
      }
    }
    return config
  },
  error => {
    // console.log('未知错误')
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    // 接口报错不显示，需要在request 里面 设置 disabledError = 1
    let disabledError = false
    try {
      disabledError = response.config.headers.disableError === 1
    } catch (error) {
      /* empty */
    }
    const code_list = ['0', 0, '003038', '003035', '003042']
    const res = response.data
    if ((res.code === null && res.success) || ((res.errorCode === '' || res.errorCode === null) && res.success) || code_list.includes(res.code)) {
      return Promise.resolve(res)
    } else {
      // 网关退出出现errorCode为09020101||09020102(账号异地登录，请重新登录)时,自动退出到ICAS登录页或第三方自有登录页
      if (res.errorCode === '09020101' || res.errorCode === '09020102') {
        store.dispatch('user/resetToken').then(() => {
          const from = getUrlKey('from') // url上源系统地址
          const loginUrl = getUrlKey('loginUrl') // url上第三方自有登录页
          if (loginUrl) {
            window.location.href = decodeURIComponent(loginUrl)
          } else if (from) {
            const sysCode = getUrlKey('sysCode') // url上源系统编码
            const lang = getUrlKey('lang') // url上语言编码
            goPage({ from, sysCode, lang })
          } else {
            goPage()
          }
        })
      } else if (res.code === '004017' || res.code === '100018' || res.code === '003037') {
        console.log(res)
      } else {
        let flag = false
        // 判断当前请求接口url是否是指定的路径
        MSG_URL.forEach(item => {
          if (response.config.url.indexOf(item) > -1) {
            flag = true
            return
          }
        })
        if (!flag && !disabledError) {
          MessageError && MessageError.close?.()
          MessageError = Message.error({
            message: res.msg || res.message || res.errorMessage || 'Has Error',
            ...messageCommmonConfig
          })
        }
      }
      return Promise.reject(res)
    }
  },
  async(error) => {
    // console.log('interceptors error ====', error.response)
    if (error.response && error.response.status !== 404) {
      const { errorMessage, msg, errorCode } = error.response.data
      // 点击退出按钮 -- 退出接口报401也可以正常退出成功 （401表示发送的请求需要有通过 HTTP 认证的认证信息）
      const shouldStopToLogin401 = getUrlKey('shouldStopToLogin401')
      if (shouldStopToLogin401 === '1') {
        Promise.reject(error)
        return
      }
      if (error.response && window.iuop.exit && error.response.status === 401) {
        Message({
          type: 'success',
          message: i18n.t('exit.success')
        })
        store.dispatch('user/resetToken').then(() => {
          const sysCode = getUrlKey('sysCode') // url上源系统编码
          const lang = getUrlKey('lang') // url上语言编码
          const from = getUrlKey('from') // url上源系统地址

          goPage({ from, sysCode, lang })

          // const sysCode = getUrlKey('sysCode') // url上源系统编码
          // const lang = getUrlKey('lang') // url上语言编码
          // const from = getUrlKey('from') // url上源系统地址
          // goPage({ from, sysCode, lang })
        })
      } else if (error.response && ((error.response.status === 403 && errorCode === '09020213') || error.response.status === 401)) {
        store.dispatch('user/resetToken').then(() => {
          const sysCode = getUrlKey('sysCode') // url上源系统编码
          const lang = getUrlKey('lang') // url上语言编码
          const from = getUrlKey('from') // url上源系统地址

          goPage({ from, sysCode, lang })
        })
      } else {
        MessageError && MessageError.close?.()
        MessageError = Message.error({
          message: errorMessage || msg || 'Has Error',
          ...messageCommmonConfig
        })
      }
    } else {
      if (error.response) {
        MessageError && MessageError.close?.()
        MessageError = Message.error({
          message: error.response.statusText || 'Has Error',
          ...messageCommmonConfig
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service

/**
 * restful API风格使用的参数匹配器，AxiosRequestConfig 中传入restData对象，
 * 若params中无对应的key，则干掉url中的"/{xxx}"
 * @param config: AxiosRequestConfig
 */
function restfulHandler(config) {
  let { url } = config
  const { restData } = config
  if (url.indexOf('{') === -1) return

  const obj = restData || {}
  const keyArr = url.match(/{(\S*?)}/g) // ['{ab}', '{bc}']
  keyArr.forEach(item => {
    const key = item.match(/{(\S*)}/)[1] // 去掉 { } 之后的key
    if (Reflect.has(obj, key)) {
      url = url.replace(item, obj[key])
      Reflect.deleteProperty(obj, key)
    } else {
      url = url.replace(`/${item}`, '')
    }
  })
  config.url = url
}
